export default __webpack_public_path__ + "static/media/map.1a1ec3b3.png";